var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3161 4.00564C13.4856 3.80509 13.6953 3.64185 13.9318 3.52632C14.1683 3.41079 14.4264 3.34551 14.6896 3.33463C14.9529 3.32376 15.2156 3.36753 15.4609 3.46316C15.7062 3.55878 15.9288 3.70417 16.1145 3.89004C16.3001 4.07592 16.4448 4.29821 16.5393 4.54275C16.6337 4.78729 16.6759 5.04871 16.6631 5.31035C16.6503 5.57199 16.5828 5.82811 16.465 6.06238C16.3471 6.29666 16.1814 6.50395 15.9785 6.67105L6.99285 15.6668L3.33203 16.6663L4.33044 13.0014L13.3161 4.00564Z",
    stroke: "#263141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.082 5.41699L14.582 7.91699",
    stroke: "#263141",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.45abadbb2dc4d8508a4108dda81b3e2e.svg";
export { ForwardRef as ReactComponent };